/* Generated code; Use nx run packages/systems/ui/icons:generate-icons
  * to regenerate this file.
  */
import React, {SVGProps} from 'react';
import type { IconProps } from '@packages/utilities/icon-support';
const createElement = React.createElement;
export default /*#__PURE__#*/ function PanelCollections(props: IconProps): React.ReactElement<SVGProps<SVGElement>> {
  const inputScale = props.scale ?? 1;
  const scale = typeof inputScale === 'number' ? inputScale : parseInt(inputScale, 10);
  return createElement('svg', {
      'data-icon': 'PanelCollections',
      'aria-hidden': true,
      focusable: false,
      width:  18 * scale,
      height: 22 * scale,
      viewBox: '0 0 18 22',
      y: props.y != null ? props.y : undefined,
      x: props.x != null ? props.x : undefined,
      className: 'bem-Svg' + (props.className ? ' ' + props.className : ''),
      style: {...{
        display: 'block',
      }, ...props.style}
    },createElement('path', {"fill":"currentColor","d":"M8.977 11.235c-2.293 0-4.47-.33-6.13-.927-.734-.264-1.353-.577-1.847-.933V12c0 1.588 3.57 2.875 7.977 2.875 4.405 0 7.977-1.287 7.977-2.876V9.374c-.493.355-1.113.667-1.847.932-1.66.6-3.836.927-6.13.927zm0 6c-2.293 0-4.47-.33-6.13-.927-.734-.264-1.353-.578-1.847-.933V18c0 1.588 3.57 2.875 7.977 2.875 4.405 0 7.977-1.287 7.977-2.875v-2.625c-.493.355-1.113.67-1.847.933-1.66.6-3.836.928-6.13.928zM8.977 1C4.57 1 1 2.287 1 3.875V6c0 1.587 3.57 2.875 7.977 2.875 4.405 0 7.977-1.287 7.977-2.875V3.875C16.954 2.287 13.384 1 8.977 1"}))
}
